import {withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {connect} from 'react-redux';
import QueryString from 'query-string';

import {
  setProductRedirect
} from '../actions/products';

/**
 * HOC that injects a "handleProductRedirect" method responsible for saving 
 * a potential "?redirect=" to session storage
 */
export const withProductRedirect = 
  compose(
    withRouter,
    connect(
      undefined, 
      (dispatch, {location}) => {
        const {
          redirect
        } = QueryString.parse(location.search);

        return {
          handleProductRedirect: (product) => {
            setProductRedirect(product, redirect);
          }
        }
      }
    )
  );


// WEBPACK FOOTER //
// ./src/containers/withProductRedirect.js